import { useEffect, useState } from "react"
import { useParams } from "react-router-dom";
import { dataDecrypt, encrypt } from "../../../app/utility/encryption-helper";
import { ApisService } from "../../../app/core/apis.service";
import { Breadcrumb } from "../../../components/breadcum";
import { FormatIndianDate } from "../../../app/utility/formatIndianDate";
import { IMAGE_PATH } from "../../../config";
import { Modal, ModalBody, ModalHeader, OverlayTrigger, Tooltip } from "react-bootstrap";
import { BiSolidInfoCircle } from "react-icons/bi";

export const RetailInvoiceView = () => {
    const params = useParams();
    const [invoiceData, setInvoiceData] = useState<any>();
    const [show, setShow] = useState<boolean>(false);

    useEffect(() => {
        getRetailInvoices({ id: params.id })
    }, []);

    const getRetailInvoices = async (data: any) => {
        try {
            let encrytedData = encrypt(JSON.stringify(data));
            const res = await ApisService.retailerApi("findInvoiceById", encrytedData);
            const retailData = JSON.parse(dataDecrypt(res?.data?.data));
            setInvoiceData(retailData[0]);
        }
        catch (error) { }
    }

    const breadcrumbInfo = [
        {
            label: "Retail Invoices",
            value: "Retail Invoices",
            routerLink: `/dashboard/organizations/org-details/${params.org}/retailer`,
            isActive: false,
        },
        {
            label: params.id,
            value: params.id,
            routerLink: ``,
            isActive: true,
        },
    ];


    const showPopup = () => {
        setShow(true);
    }

    const closePopup = () => {
        setShow(false);
    }

    return (
        <div className="container-fluid content-bg-color">
            <Breadcrumb breadCrumbList={breadcrumbInfo}></Breadcrumb>
            <div className="card">
                <div className="card-body">
                    <h5 className="fw-bold primary-color mb-0">Basic Details</h5>
                    <div className="row">
                        <div className="col-md-3 my-2 lh-1-5">
                            <div className="fw-bold">Invoice Number</div>
                            <div>{invoiceData?.invoice_number > 10 ? invoiceData?.invoice_number : `0${invoiceData?.invoice_number}`}</div>
                        </div>
                        <div className="col-md-3 my-2 lh-1-5">
                            <div className="fw-bold">Seller Name</div>
                            <div>{invoiceData?.seller?.name}</div>
                        </div>
                        <div className="col-md-3 my-2 lh-1-5">
                            <div className="fw-bold">Seller Contact</div>
                            <div>{invoiceData?.seller?.mobile_number}</div>
                        </div>
                        <div className="col-md-3 my-2 lh-1-5">
                            <div className="fw-bold">Buyer Name</div>
                            <div>{invoiceData?.buyer?.name}</div>
                        </div>
                        <div className="col-md-3 my-2 lh-1-5">
                            <div className="fw-bold">Buyer Contact</div>
                            <div>{invoiceData?.buyer?.mobile_number}</div>
                        </div>
                        <div className="col-md-3 my-2 lh-1-5">
                            <div className="fw-bold">Created Date</div>
                            <div>{FormatIndianDate(invoiceData?.invoice_details?.invoice_date, "")}</div>
                        </div>
                        <div className="col-md-3 my-2 lh-1-5">
                            <div className="fw-bold">Invoice Amount</div>
                            <div>₹ {invoiceData?.invoice_details?.invoice_amount}</div>
                        </div>
                        <div className="col-md-3 my-2 lh-1-5">
                            <div className="fw-bold">Paid Amount</div>
                            <div>₹ {invoiceData?.invoice_details?.amount_paid || 0}</div>
                            {invoiceData?.invoice_details?.amount_paid > 0 && <button className="primary-bg text-white rounded primary-border w-50 py-1 my-2" onClick={() => { showPopup() }}>History</button>}
                        </div>
                        <div className="col-md-3 my-2 lh-1-5">
                            <div className="fw-bold">Pending Amount</div>
                            <div>₹ {invoiceData?.invoice_details?.pending_amount || 0}</div>
                        </div>
                    </div>
                    <h5 className="primary-color fw-bold">Product Details</h5>
                    {invoiceData?.invoice_details?.products?.map((value: any, index: any) => (
                        <div className="card mb-2" key={index}>
                            <div className="card-body">
                                <div className="row align-items text-center">
                                    <div className="col-md-1">
                                        <img src={IMAGE_PATH + '/' + value.product_image} alt="product Image" className="w-100-h-100" />
                                    </div>
                                    <div className="col-md-4">
                                        <div className="fw-bold">{value?.product_name}</div>
                                    </div>
                                    <div className="col-md-1">
                                        <div className="fw-bold">Quantity</div>
                                        {value?.quantity}
                                    </div>
                                    <div className="col-md-2">
                                        <div className="fw-bold">Batch No</div>
                                        {value?.batch_number}</div>
                                    <div className="col-md-2">
                                        <div className="fw-bold">Unit Price</div>
                                        ₹ {value?.unit_price}
                                    </div>
                                    <div className="col-md-2">
                                        <div className="fw-bold">Sale Price</div>
                                        ₹ {value?.unit_price * value?.quantity}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <Modal show={show} onHide={closePopup} centered>
                <ModalHeader closeButton className=""><h5 className="mb-0 fw-bold">Payment History</h5></ModalHeader>
                <ModalBody>
                    <table className="w-100 table">
                        <thead>
                            <tr className="text-center">
                                <th scope="col">S.No</th>
                                <th scope="col">Payment Date</th>
                                <th scope="col">Amount (₹)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {invoiceData?.invoice_details?.payments?.map((value: any, index: any) => (
                                <tr key={index} className="text-center">
                                    <td>{index + 1}</td>
                                    <td>{FormatIndianDate(value?.created_dt, "datetime")}</td>
                                    <td>{value?.value}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </ModalBody>
            </Modal>
        </div>
    )
}